import { GATES } from '../constants/auth';
import { useGetIsUngated } from './useGetIsUngated';
export const useHasV2ApprovalEditorButtons = () => {
  const getIsUngated = useGetIsUngated();
  return getIsUngated(GATES.V2_APPROVAL_EDITOR_BUTTONS);
};